import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { translations, getTranslation } from '../lib/i18n';

const LanguageContext = createContext(null);

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within LanguageProvider');
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        // Get saved language or detect from browser
        const saved = localStorage.getItem('language');
        if (saved && (saved === 'en' || saved === 'id')) {
            return saved;
        }
        // Detect browser language
        const browserLang = navigator.language.toLowerCase();
        if (browserLang.startsWith('id')) {
            return 'id';
        }
        return 'en';
    });

    useEffect(() => {
        localStorage.setItem('language', language);
        document.documentElement.lang = language;
    }, [language]);

    const t = useCallback((key) => {
        return getTranslation(language, key);
    }, [language]);

    const switchLanguage = useCallback((lang) => {
        if (lang === 'en' || lang === 'id') {
            setLanguage(lang);
        }
    }, []);

    const toggleLanguage = useCallback(() => {
        setLanguage(prev => prev === 'en' ? 'id' : 'en');
    }, []);

    return (
        <LanguageContext.Provider value={{
            language,
            setLanguage: switchLanguage,
            toggleLanguage,
            t,
            isEnglish: language === 'en',
            isIndonesian: language === 'id'
        }}>
            {children}
        </LanguageContext.Provider>
    );
};
